module.exports = __webpack_public_path__ + "img/右侧信息@2x.73469529.png";